/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, "body{height:100%;font-family:HanHei TC,PingFang TC,Helvetica Neue,Helvetica,STHeitiTC-Light,Arial,sans-serif;font-style:normal;font-weight:200}a{cursor:pointer;color:rgba(0,0,0,.5)}h1{font-size:2em}h1,h2{font-weight:200}h2{font-size:1.4em}p{font-size:1em}ul{-webkit-padding-start:0}li{list-style:none}.ui.top.fixed.menu{height:auto;margin-left:auto!important;margin-right:auto!important;padding:5px 0;background-color:transparent;border:none;display:flex;flex-direction:column;justify-content:center;box-shadow:none}header .logo{display:inline-block;position:relative;left:10px;width:46px}header .link-logo{display:inline-block;padding:.2em}header .link-logo img{vertical-align:middle}header .nav-hamburger{position:absolute;right:5px;width:50px;height:56px;text-align:center;padding:.4em;display:flex;flex-direction:column;justify-content:center}header .nav-hamburger img{height:28px}header .nav-list{display:none;position:fixed;height:100vh;width:100vw;top:56px;left:0;background-color:hsla(0,0%,100%,.9)}header .nav-list a{text-align:center;display:block;padding:1.5vh;border-top:1px solid;border-color:rgba(0,0,0,.5)}header .nav-list a:last-child{border-bottom:1px solid}.topic-title{position:fixed;text-align:center;top:15vh;right:0;left:0}.topic-title img{width:80vw}.brush-img{position:fixed;text-align:center;right:0;left:0;top:10vh}.brush-img img{position:relative;width:80px}.scene{height:100vh;padding-top:56px;opacity:0}#scene1 .scene-content{position:static}.scene-content{height:100%;margin:0 auto}.mullet-intro{position:fixed;width:80vw;text-align:center;top:50%;left:50%;transform:translate(-50%)}.mullet-intro p{margin-bottom:.4em}.mullet-img{position:relative;text-align:center;top:34vh;right:0;left:0}.mullet-img img{height:13vh}.mullet-img-fixed{position:fixed!important;text-align:center;top:20vh;right:0;left:0}.mullet-position-text{top:12.5vh}.mullet-position,.mullet-position-text{position:fixed;text-align:center;right:0;left:0}.mullet-position{top:20vh}.mullet-position img{height:13vh}.dish-img{position:relative;text-align:center;top:35vh;right:0;left:0}.dish-img img{height:30vh}.dish-img-fixed{position:fixed!important;text-align:center;top:35vh;left:50%;transform:translate(-50%);height:30vh;width:30vh;border-radius:99em;box-shadow:3px 3px 3px rgba(0,0,0,.1)}.dish-img-fixed img{height:30vh}.dish-intro{width:75vw;margin:0 auto;position:fixed;text-align:center;top:67vh;left:0;right:0}.dish-intro h2{margin-bottom:.3rem}.dish-intro p{font-size:.7em;margin:0;text-align:left}.footer{padding:55px 122px}.footer .item.section{padding-bottom:20px!important;font-size:20px;font-weight:700;letter-spacing:1.9px}.footer .item{font-size:17px;font-weight:400}.footer .ui.center.aligned.grid{margin:70px 0 0!important}#scene1{opacity:1}#scene10 .scene{height:50vh}#scene10 .related-report{width:90vw;margin:0 auto}#scene10 h3,#scene10 li{text-align:center}#scene10 li{padding:.4vh 0}@media only screen and (min-width:768px) and (max-width:991px){header .logo{left:20px}header .nav-hamburger{right:15px}.topic-title{top:10vh}.topic-title img{width:70vw}.brush-img{top:10vh}.brush-img img{width:100px}.mullet-intro p{font-size:1.6em}.mullet-img{top:38vh}.mullet-img img{height:15vh}.mullet-img-fixed{top:18vh}.mullet-position-text{top:12vh}.mullet-position{top:18vh}.mullet-position img{height:15vh}.dish-img{top:42vh}.dish-img img{height:30vh}.dish-img-fixed{top:42vh}.dish-img-fixed img{height:30vh}.dish-intro{width:70vw;top:75vh}.dish-intro h2{margin-bottom:1rem}.dish-intro p{font-size:1.2em}#scene10 .related-report{padding-top:50px}#scene10 li{font-size:1.4em;padding:1.2vh 0}}@media only screen and (min-width:992px) and (max-width:1199px){header .logo{left:30px}header .nav-hamburger{right:25px}.topic-title{text-align:right;top:25vh;right:30vw}.topic-title img{width:20vw}.brush-img{display:none}.mullet-intro{position:fixed;width:30vw;text-align:center;top:35vh;left:26vw}.mullet-img{position:fixed;text-align:right;top:50vh;right:10vw}.mullet-img img{height:20vh}.mullet-position-text{text-align:right;top:72vh;right:15vw;font-size:1.5em;color:#4291aa}.mullet-position{text-align:right;top:50vh;right:10vw}.mullet-position img{height:20vh}.dish-img{position:fixed;text-align:left;top:25vh;left:10vw}.dish-img img{height:40vh}.dish-img-fixed{top:25vh;left:16vw;transform:translate(-16%);height:40vh;width:40vh}.dish-img-fixed img{height:40vh}.dish-intro{width:35vw;top:68vh;left:10vw;margin:0}.dish-intro h2{margin-bottom:.5rem}.dish-intro p{text-align:justify;word-break:break-all;font-size:1em}}@media only screen and (min-width:1200px){header .logo{left:30px}header .nav-hamburger{right:25px}.topic-title{text-align:right;top:18vh;right:30vw}.topic-title img{width:20vw}.brush-img{display:none}.mullet-intro{position:fixed;width:30vw;text-align:center;top:35vh;left:25vw;font-size:1.8em}.mullet-img{position:fixed;text-align:right;top:48vh;right:22vw}.mullet-img img{height:22vh}.mullet-position-text{text-align:right;top:72vh;right:28vw;font-size:1.5em;color:#4291aa}.mullet-position{text-align:right;top:48vh;right:22vw}.mullet-position img{height:22vh}.dish-img{position:fixed;text-align:left;top:27vh;left:10vw}.dish-img img{height:42vh}.dish-img-fixed{top:25vh;left:15vw;transform:translate(-15%);height:42vh;width:42vh}.dish-img-fixed img{height:42vh}.dish-intro{width:35vw;top:70vh;left:7vw;margin:0}.dish-intro h2{margin-bottom:1.4rem;font-size:1.8em}.dish-intro p{text-align:justify;word-break:break-all;font-size:1.2em}}@media only screen and (min-width:992px){.ui.top.fixed.menu{flex-direction:row;justify-content:flex-start}header .logo,header .nav-list{display:inline-block}header .nav-list{position:relative;top:0;left:40px;height:auto;width:auto;padding-top:14px;padding-bottom:14px}header .nav-list a{display:inline;padding:0 10px;border:none}header .nav-list a:last-child{border:none}.subscribe{width:100%!important}#scene10 .related-report{padding-top:65px}#scene10 li{font-size:1.4em;padding:1.2vh 0}}@media only screen and (min-width:1365px){.topic-title{right:25vw}.mullet-img,.mullet-position{right:18vw}.mullet-intro{font-size:1.4em}.dish-intro p{font-size:1.2em}}@media only screen and (min-width:1439px){.mullet-img,.mullet-position{right:15vw}}@media only screen and (min-width:1599px){.dish-intro{width:30vw;top:70vh;left:9vw;margin:0}.dish-intro p{font-size:1.4em}}", ""]);
	
	// exports


/***/ },
/* 2 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./styles.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./styles.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	if (false) {
	  module.hot.accept()
	}
	
	__webpack_require__(4)
	__webpack_require__(6)


/***/ },
/* 6 */
/***/ function(module, exports) {

	$(function () {
	
		var windowHeight = $(window).innerHeight();
		var windowWidth = $(window).innerWidth();
	
		var controller = new ScrollMagic.Controller();
	
		$(window).resize(function() {
			if ($(window).innerWidth() !== windowWidth) {
				location.reload();
			}
		});
	
		// Mobile Version Fix
		if (windowWidth < 992) {
			var hamburgerClicked = false;
	
			$('#brush-img').css('opacity', '0');
	
			$('.mobile-hide').hide();
	
			$('.hamburger-link').click(function() {
			  if (hamburgerClicked) {
			  	$('.nav-list').hide();
			  	hamburgerClicked = false;
			  } else {
			  	$('.nav-list').show();
			  	hamburgerClicked = true;
			  }
	
			});
	
			$('.nav-list-item').click(function() {
				$('.nav-list').hide();
			});
	
			new ScrollMagic.Scene({
								triggerElement: '#scene2', 
								duration: 0.5*windowHeight,
								offset: -0.5*windowHeight
							})
							.setTween('#topic-title', 1, {opacity: 0})
							.addTo(controller);
	
			new ScrollMagic.Scene({
								triggerElement: '#scene3', 
								duration: 1*windowHeight,
								offset: -0.5*windowHeight
							})
							.setTween('#brush-img', 1, {opacity: 1})
							.addTo(controller);
	
			new ScrollMagic.Scene({
								triggerElement: '#scene2', 
								duration: 9.3*windowHeight,
								offset: -0.3*windowHeight
							})
							.setClassToggle("#mullet1", "mullet-img-fixed")
							.addTo(controller);
		}
	
		if (windowWidth > 991) {
			$('.nav-hamburger').hide();
	
			$(document).on('click', '.nav-list-item', function(event){
			    event.preventDefault();
	
			    $('html, body').animate({
			        scrollTop: $( $.attr(this, 'href') ).offset().top
			    }, 500);
			});
		}
	
		// Page 2
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene2', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#dish1', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene2', 
							duration: 1*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene2', 1, {opacity: 1})
						.addTo(controller);
	
		// Page 3
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene3', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#mullet-intro', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene3', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene3', 1, {opacity: 1})
						.addTo(controller);
	
		// Page 4
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene4', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene3', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene4', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene4', 1, {opacity: 1})
						.addTo(controller);
		
		// Page 5
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene5', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene4', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene5', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene5', 1, {opacity: 1})
						.addTo(controller);
	
		// Page 6
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene6', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene5', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene6', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene6', 1, {opacity: 1})
						.addTo(controller);
	
		// Page 7
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene7', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene6', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene7', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene7', 1, {opacity: 1})
						.addTo(controller);
	
		// Page 8
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene8', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene7', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene8', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene8', 1, {opacity: 1})
						.addTo(controller);
		// Page 9
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene9', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene8', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene9', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene9', 1, {opacity: 1})
						.addTo(controller);
	
		// Page 10
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene10', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene9', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene10', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#brush-img', 1, {opacity: 0})
						.addTo(controller);
						
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene10', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#topic-title', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene10', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('.dish-img-fixed', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade out
							triggerElement: '#scene10', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#mullet1', 1, {opacity: 0})
						.addTo(controller);
	
		new ScrollMagic.Scene({  // fade in
							triggerElement: '#scene10', 
							duration: 0.5*windowHeight,
							offset: -0.5*windowHeight
						})
						.setTween('#scene10', 1, {opacity: 1})
						//.addIndicators({ name:'scene9' })
						.addTo(controller);		
	});


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// bundle.js